import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
import { DescriptionSection, InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import CommunicationsDetailsSectionInfo from './details/sections/CommunicationsDetailsSectionInfo';

import CommunicationsEvents from './CommunicationsEvents';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			<InlineTitle text="DETAILS_INFO_SECTION" />
			<CommunicationsDetailsSectionInfo {...props} />

			<InlineTitle text="DETAILS_DESCRIPTION_SECTION" />
			<DescriptionSection
				name="coms_descriptionhtml"
				value={props.model.coms_descriptionhtml}
				isEdit={props.isEdit}
				sendChange={props.sendChange}
			/>
		</>
	),
	events: CommunicationsEvents,
	showOpenFullDetails: true
};

export default dialogSettings;
